module.exports = __webpack_public_path__ + "static/media/cnhOk.d108b108.jpg";